const ClosedFolderIcon = () => {
  return (
    <svg
      width="30"
      height="28"
      viewBox="0 0 30 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.25 4.91846V7.54346H9.1935C9.49177 7.54319 9.77772 7.4245 9.9885 7.21346L12.2835 4.91846L9.9885 2.62346C9.77772 2.41242 9.49177 2.29372 9.1935 2.29346H4.875C4.17881 2.29346 3.51113 2.57002 3.01884 3.0623C2.52656 3.55458 2.25 4.22226 2.25 4.91846ZM0 4.91846C0 3.62553 0.513614 2.38555 1.42785 1.47131C2.34209 0.557071 3.58207 0.043457 4.875 0.043457H9.1935C10.0881 0.043847 10.9459 0.399391 11.5785 1.03196L14.343 3.79346H25.1265C26.4192 3.79385 27.6588 4.30765 28.5727 5.22184C29.4866 6.13604 30 7.37579 30 8.66846V22.1685C30 22.8087 29.8739 23.4426 29.6289 24.034C29.3839 24.6255 29.0248 25.1629 28.5721 25.6156C28.1195 26.0683 27.582 26.4274 26.9906 26.6724C26.3991 26.9174 25.7652 27.0435 25.125 27.0435H4.875C3.58207 27.0435 2.34209 26.5298 1.42785 25.6156C0.513614 24.7014 0 23.4614 0 22.1685V4.91846ZM2.25 9.79346V22.1685C2.25 23.6175 3.426 24.7935 4.875 24.7935H25.125C25.8212 24.7935 26.4889 24.5169 26.9812 24.0246C27.4734 23.5323 27.75 22.8647 27.75 22.1685V8.66846C27.75 7.97226 27.4734 7.30458 26.9812 6.8123C26.4889 6.32002 25.8212 6.04346 25.125 6.04346H14.34L11.58 8.80496C11.2666 9.11835 10.8945 9.36695 10.4851 9.53656C10.0756 9.70617 9.63671 9.79346 9.1935 9.79346H2.25Z"
        fill="#77778C"
      />
    </svg>
  );
};
export default ClosedFolderIcon;
